import { observer } from "mobx-react-lite";
import React, { useState, useEffect } from "react";
import Layout from "../../components/layout/Layout";
import i18n from "../../i18n";
import AboutRU from "./AboutRU";
import AboutUK from "./AboutUK";
import AboutEN from "./AboutEN";
import { useTranslation } from "react-i18next";
import SeoHead from "../../components/elements/SeoHead";

const AboutCompany = observer(() => {
    const [language, setLanguage] = useState(i18n.language);
    const { t } = useTranslation();

    useEffect(() => {
        const link = document.createElement('link');
        link.href = 'https://fonts.googleapis.com/css2?family=Roboto:ital,wght@0,100..900;1,100..900&family=Rubik+Doodle+Shadow&display=swap';
        link.rel = 'stylesheet';
        document.head.appendChild(link);

        const handleLanguageChange = () => {
            setLanguage(i18n.language);
        };

        i18n.on("languageChanged", handleLanguageChange);
        return () => {
            i18n.off("languageChanged", handleLanguageChange);
        };
    }, []);

    const containerStyle: React.CSSProperties = {
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
        width: "100%",
        overflow: "hidden",
        margin: "0 auto",
        maxWidth: "100%",
    };

    const imageStyle: React.CSSProperties = {
        width: "100%",
        height: "auto",
        objectFit: "cover",
        maxHeight: "100%",
    };

    return (
        <Layout headerStyle={1} footerStyle={2} >
            <SeoHead metaKey="seo.about" />
            <div >
                <AboutEN />
            </div>
        </Layout>
    );
});

export default AboutCompany;
